import { render, staticRenderFns } from "./Feriado.vue?vue&type=template&id=6976f61a&scoped=true"
import script from "./Feriado.vue?vue&type=script&lang=js"
export * from "./Feriado.vue?vue&type=script&lang=js"
import style0 from "./Feriado.vue?vue&type=style&index=0&id=6976f61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976f61a",
  null
  
)

export default component.exports